import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { useDebouncedCallback } from "use-debounce";

import Button from "../../../../shared/components/Buttons/Button";
import SearchField from "../../../../shared/components/searchField/SearchField";
import {
  buttonNameConstants,
  buttonTypeConstants,
  EMPTY_STRING,
} from "../../../../constants";
import { parseToThousandSeperatorDecimalNumber } from "../../../../shared/utility";

const GiftCardPayment = ({
  transactionData,
  setPaymentMethod,
  handleGiftCardPayment,
  giftCardDetails,
  getGiftCardDetails,
  emptyGiftCardDetails,
}) => {
  const [giftCardItem, setGiftCardItem] = useState({
    barcode: EMPTY_STRING,
  });
  const getGiftCard = async () => {
    getGiftCardDetails(transactionData?.store?.id, giftCardItem.barcode);
  };
  const debouncedMakeHttpRequest = useDebouncedCallback(getGiftCard, 2000);

  const handleSearchFieldChange = (value) => {
    setGiftCardItem({ ...giftCardItem, barcode: value });
    debouncedMakeHttpRequest();
  };
  //-------handle hide modal
  const handleCancelPayment = () => {
    setGiftCardItem({
      barcode: EMPTY_STRING,
    });
    emptyGiftCardDetails();
  };

  // let subTotal =
  //   Number(transactionData.subTotal) - Number(transactionData.discount);
  // let paymentAmount =
  //   Number(transactionData.currentAmountToPay) > subTotal
  //     ? subTotal
  //     : transactionData.currentAmountToPay;

  return (
    <div className="payment-cash-card-wrapper">
      <Row className="m-0">
        <Col
          md={12}
          className="d-flex justify-content-between align-items-center"
        >
          <span className="cash-heading">Gift Card</span>
        </Col>
        <Col md={12} className="mt-3">
          <div className="receipt-total-wrapper d-flex flex-column gap-1">
            <span>Payment Amount</span>
            <span>
              $
              {parseToThousandSeperatorDecimalNumber(
                transactionData.currentAmountToPay
              )}
            </span>
          </div>
        </Col>
        <Col md={12} className="mt-3">
          <div className=" d-flex flex-column gap-1">
            <SearchField
              placeHolder="Enter/Scan Gift Card Barcode"
              className="barcode-payment-field"
              onChange={(e) => handleSearchFieldChange(e.target.value)}
            />
          </div>
        </Col>
        {giftCardDetails && (
          <Col
            md={12}
            className="mt-3 d-flex justify-content-between align-items-center balance-wrapper"
          >
            <span>Balance</span>
            <span>
              $
              {parseToThousandSeperatorDecimalNumber(
                giftCardDetails?.giftCardBalance || 0
              )}
            </span>
          </Col>
        )}
        <Col md={12} className="mb-3 d-flex gap-2 mt-3">
          <Button
            type="button"
            label={buttonNameConstants.BACK}
            handleClick={() => {
              setPaymentMethod("");
              handleCancelPayment();
            }}
            buttonType={buttonTypeConstants.GHOST_BUTTON}
            className="w-100"
          ></Button>
          <Button
            type="button"
            className="w-100"
            label={buttonNameConstants.COMPLETE}
            handleClick={() => handleGiftCardPayment()}
            isDisabled={
              giftCardDetails && giftCardDetails.giftCardBalance > 0
                ? false
                : true
            }
          ></Button>
        </Col>
      </Row>
    </div>
  );
};

export default GiftCardPayment;
